// NOTE:
// I couldn't find your prepared dataset in the repo yet.
// Replace the contents of `projectsTimeline` with your prepared code.

export const projectsTimeline = [
  {
    id: 'coral',
    period: '04/2024–02/2026',
    year: 2024,
    title: 'Coral — AI Platform',
    context: 'NDA (full-time role). Public link points to the company website.',
    image: '/images/portfolio/coral.webp',
    role: 'Lead Front-End Developer',
    stack: ['Vue', 'Nuxt', 'TailwindCSS'],
    summary:
      'Frontend leadership for a complex product: performance-focused UI, predictable behavior, and a maintainable codebase.',
    bullets: [
      'Designed and built the entire front-end foundation',
      'Optimized performance',
      'Led code reviews and UI consistency standards',
      'Developed a Shopify plugin',
    ],
    links: [
      {
        label: 'Company website',
        href: 'https://www.coral.li/',
        kind: 'external',
      },
    ],
  },
  {
    id: 'taro-3d',
    period: '2026',
    year: 2026,
    title: 'Dennis Valchez — 3D Tarot Experience & Booking Platform',
    context:
      'Client project (full-stack). Public link points to the live website.',
    image: '/images/portfolio/taro-3d.webp',
    role: 'Full-Stack Developer',
    stack: ['React', 'Three.js', 'React Three Fiber', 'Django', 'Stripe'],
    summary:
      'A production website for a Sydney-based psychic & tarot brand: an immersive 3D tarot experience combined with a real business platform — service booking, payments, bilingual content, and a custom admin panel.',
    bullets: [
      'Built animated 3D scenes and interactive tarot card presentation (Three.js / R3F)',
      'Implemented Stripe-powered booking across seven service offerings',
      'Developed an advanced Django admin panel for content, orders, and readings',
      'Shipped EN/RU localization, Card of the Day, and interactive deck galleries',
    ],
    links: [
      {
        label: 'Live website',
        href: 'https://dennisvalchez.com/',
        kind: 'external',
      },
    ],
  },
  {
    id: 'fitness-platform',
    period: '2025',
    year: 2025,
    title: 'ArinsBodyfit — Fitness Platform',
    context:
      'Side project (full-stack). Public link points to the live website.',
    image: '/images/portfolio/arinsbodyfit.webp',
    role: 'Full-Stack Developer',
    stack: ['Vue', 'Nuxt'],
    summary:
      'An ecosystem combining a conversion-focused landing page with a workout platform and admin tools.',
    bullets: [
      'Built user accounts and workout dashboards',
      'Implemented training content flows and platform structure',
      'Developed an admin panel for managing workouts and users',
    ],
    links: [
      {
        label: 'Live website',
        href: 'https://arinsbodyfit.com/',
        kind: 'external',
      },
    ],
  },

  {
    id: 'parabl',
    period: '10/2018–10/2023',
    year: 2018,
    title: 'Parabl — Frontend Leadership & System Rebuild',
    context: 'NDA (full-time role). Public link points to the company website.',
    image: '/images/timeline/similie.jpg',
    role: 'Front-End Lead',
    stack: ['AngularJS', 'Angular', 'React', 'Bootstrap', 'Micro-Frontends'],
    summary:
      'Major UI work in a legacy codebase: redesign, scalable styling system, and theming for long-term maintainability.',
    bullets: [
      'Led a full redesign and implementation of a complex UI',
      'Established a scalable BEM-based styling system',
      'Shipped light/dark theme customization',
      'Improved maintainability in a legacy codebase',
    ],
    links: [
      {
        label: 'Company website',
        href: 'https://similie.com/',
        kind: 'external',
      },
    ],
  },
  {
    id: 'divine-muse-design',
    period: '2023',
    year: 2023,
    title: 'Divine Muse Design — Responsive Website',
    context: 'Project delivery (website).',
    image: '/images/portfolio/dmd.jpg',
    role: 'Full-Stack Developer',
    stack: ['WordPress', 'WooCommerce'],
    summary:
      'A responsive, conversion-focused storefront experience with minimal UI to keep the visual identity front and center.',
    bullets: [
      'Built a responsive layout optimized for mobile and desktop',
      'Kept UI minimal to emphasize product photography',
      'Improved navigation clarity for browsing and purchase flows',
    ],
    links: [],
  },
  {
    id: 'payever',
    period: '03/2018–08/2018',
    year: 2018,
    title: 'Payever — Angular Apps & UI Kit',
    context: 'NDA (full-time role). Public link points to the company website.',
    image: '/images/timeline/payever.jpg',
    role: 'Front-End Developer',
    stack: ['Angular 6'],
    summary:
      'Built complex Angular applications with reusable UI-kit components to keep UX consistent and code maintainable.',
    bullets: [
      'Developed complex Angular 6 applications',
      'Built reusable UI-kit components for consistent UX',
      'Supported maintainability through code reviews',
      'Improved style-system organization',
    ],
    links: [
      {
        label: 'Company website',
        href: 'https://payever.de/',
        kind: 'external',
      },
    ],
  },

  {
    id: 'namogoo',
    period: '2019',
    year: 2019,
    title: 'Namogoo — Event Roulette Mobile App',
    context: 'NDA (project role).',
    image: '/images/timeline/namogoo.jpg',
    role: 'Front-End Developer',
    stack: ['Cordova'],
    summary:
      'A Cordova-based event app with probability-driven prize awarding, animation, and a hidden admin panel.',
    bullets: [
      'Implemented the roulette animation and user flow',
      'Built probability-driven prize awarding logic',
      'Created a hidden admin panel for settings and exports',
      'Added configuration tools for prize generation',
    ],
    links: [],
  },

  {
    id: 'brobotics',
    period: '07/2016–03/2018',
    year: 2016,
    title: 'Brobotics — Interactive Front-End Applications',
    context: 'NDA (full-time role).',
    image: '/images/timeline/brobotics.jpg',
    role: 'Front-End Developer',
    stack: ['Angular', 'TypeScript'],
    summary:
      'Built interactive single-page applications and helped standardize UI structure for consistency and long-term maintenance.',
    bullets: [
      'Developed interactive front-end applications with Angular and TypeScript',
      'Improved UI consistency by standardizing component structure',
      'Applied BEM methodology for scalable styling patterns',
      'Collaborated closely with product and engineering stakeholders',
    ],
    links: [],
  },
];
